(function () {
  var BAD = 'google drive';
  var GOOD = 'Google Drive';
  function fixOnce(root) {
    if (!root) return;
    var labels = root.querySelectorAll('label, .gpo-label, [class*="gpo"] span, [class*="gpo"] div');
    for (var i = 0; i < labels.length; i++) {
      var el = labels[i];
      if (!el || !el.childNodes) continue;
      for (var j = 0; j < el.childNodes.length; j++) {
        var n = el.childNodes[j];
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.toLowerCase().indexOf(BAD) !== -1) {
          n.nodeValue = n.nodeValue.replace(/google drive/gi, GOOD);
        }
      }
    }
  }
  function schedule() {
    fixOnce(document);
    // Globo injects late: few delayed passes, no MutationObserver
    setTimeout(function () { fixOnce(document); }, 500);
    setTimeout(function () { fixOnce(document); }, 1500);
    setTimeout(function () { fixOnce(document); }, 3000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
